;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import * as Sentry from '@sentry/nextjs';
import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';

// 4xx van de API = ongeldige input of iets dat niet (meer) bestaat, geen bug. De API meldt zijn eigen fouten zelf.
const isClientError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) return false;
  const status = error.response?.status;
  return !!status && status >= 400 && status < 500;
};

export function logSentryError(error: unknown): void {
  if (isProduction && !isClientError(error)) Sentry.captureException(error);
  else console.error(error);
}

export function addBreadcrumb(breadcrumb: Sentry.Breadcrumb): void {
  if (isProduction) Sentry.addBreadcrumb(breadcrumb);
  else console.log(breadcrumb);
}
